import React from "react";
import { useHistory } from "react-router-dom";
import { Col, Container, Image, Row } from "react-bootstrap";
import ErrorImg from "../images/404.svg";

const NoMatch = () => {
    const history = useHistory();
    const handleToLogin = () => {
        history.push("/");
    };
    return (
        <Container>
            <Row className="justify-content-center pt-5">
                <Col md="4" xs="8">
                    <Image src={ErrorImg} fluid />
                </Col>
            </Row>

            <Row className="justify-content-center pt-5">
                <Col md="auto" xs="auto">
                    <p className="titles">
                        Ups, parece ser que aqui no hay nada
                    </p>
                </Col>
            </Row>

            <Row className="justify-content-center pt-2">
                <Col md="auto" xs="auto">
                    <button className="button-text" onClick={handleToLogin}>
                        Volver al inicio
                    </button>
                </Col>
            </Row>
        </Container>
    );
};

export default NoMatch;
